import hotkeys, { type KeyHandler } from "hotkeys-js";
import { useEffect } from "react";

export const useHotkeys = (keys: string, callback: KeyHandler) => {
    useEffect(() => {
        hotkeys(keys, callback);
        return () => {
            hotkeys.unbind(keys, callback);
        };
    }, [keys, callback]);
};
